<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">工作人员</div>
            <el-input v-model="userName" disabled ></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">活动名称</div>
            <el-input v-model="activityContentName" placeholder="请输入排序" disabled ></el-input>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" class="item">
            <div class="label">开始时间</div>
              <el-date-picker
                  v-model="startTime"
                  type="datetime"
                  style="width:100%;"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="开始时间">
              </el-date-picker>

          </el-col>
          <el-col :span="12" class="item">
            <div class="label">结束时间</div>
              <el-date-picker
                  v-model="endTime"
                  type="datetime"
                  style="width:100%;"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="结束时间">
              </el-date-picker>

          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      userName:'',
      activityContentName:'',
      activityOrderCode:'',
      userCode:'',
      startTime:'',
      endTime:'',
      activityUserCode:'',

    }
  },
  methods: {
    init(row){

      this.userName = row.userName;
      this.activityContentName = row.activityOrderDTO.activityContentName;
      this.activityOrderCode = row.activityOrderCode;
      this.userCode = row.userCode;
      this.startTime = timefilters(row.startTime);
      this.endTime =timefilters(row.endTime);
      this.activityUserCode = row.activityUserCode;

    },

    closeSelf() {
      this.$emit("closeEdit");
    },

    confirm(){

      if(this.startTime === ''){
        this.$message("选择开始时间");
        return;
      }
      if(this.endTime === ''){
        this.$message("选择结束时间");
        return;
      }



      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityUser/EditTime',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          startTime:this.startTime,
          endTime:this.endTime,
          activityUserCode:this.activityUserCode,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },




  }
}
</script>

